// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eb8xJ","content":"styles_content__fxS_Z"};